import { IService, IServiceCategory } from '@core/interfaces/category';
import { IBookingFormField } from './booking-form';

export interface ICustomer {
  birthDate: string,
  city: string,
  country: string,
  firstName: string,
  id: number,
  lastName: string,
  registrationDate: string,
  timeZone: null
  user: IUser,
  userId: string,
  avatarPath?: string,
}

export interface IUser {
  id: string,
  customerProfileId: number,
  userName: string,
  email: string,
  emailConfirmed: boolean,
  userType: UserType,
  avatarPath: string,
  firstName: string,
  lastName: string,
  phoneNumber: string,
  culture?: string,
  businessName?: string,
}

export interface ICustomerBase {
  firstName: string,
  id: number,
  lastName: string,
  avatarPath?: string,
  email: string,
  phoneNumber: string
}

export enum UserType {
  Business = "Business",
  Customer = "Customer",
  TeamMember = "TeamMember"
}

export interface UserCreate {
  firstName: string,
  lastName: string,
  email: string,
  password: string,
  confirmPassword: string,
  phone: string,
  culture: string,
}

export interface BusinessUserCreate {
  firstName: string,
  lastName: string,
  email: string,
  password: string,
  confirmPassword: string,
  phone: string,
  address: BusinessAddress,
  businessName: string,
  culture: string,
}

export interface IBusinessBaseInfo {
  id: number,
  businessName: string,
  avatarPath?: string,
  email: string,
  phone: string,
  categoryId: number,
  category: Category,
  address: BusinessAddress,
}

export interface IBusiness {
  birthDate: string,
  businessName: string,
  firstName: string,
  id: number,
  lastName: string,
  registrationDate: string,
  user: IUser,
  userId: string,
  avatarPath?: string,
  coverImage?: string,
  galleryImages?: IGallery[],
  address: BusinessAddress,
  license: AccountLicense,
  description?: string,
  about?: string,
  facebookUrl?: string,
  googleUrl?: string,
  instagramUrl?: string,
  currency: Currency,
  embedThemeSettings?: IBusinessEmbedThemeSettings | null
  bookingFormFields?: IBookingFormField[]
}

export interface ITeamMember {
  id: number,
  userId: string,
  businessProfileId: number,
  about:string,
  title: string,
  color: string,
  firstName: string,
  lastName: string,
  birthDate: string,
  startDate: string,
  status: TeammeberStatus
  services: Array<IService>,
  avatarPath: string,
  phone: string,
  email: string
  scheduleId?: number,
  toolIds?: number[]
}

export enum TeammeberStatus {
  Active = "Active",
  Inactive = "Inactive",
  Pending = "Pending"
}

export interface Currency {
  id: number,
  name: string,
  code: string,
  symbol: string,
  symbolNative: string,
  decimalDigits: number,
  rounding: number,
  namePlural: string
}

export interface ILoginResult {
  success: boolean,
  token: string,
  refreshToken: string,
  errors: string[],
  validTo: Date,
  user: any
}

export interface IGallery {
  businessProfileId: number,
  id: number,
  path: string
}

export interface BusinessAddress {
  country: string,
  city: string,
  zipCode: string,
  street: string,
  apartment: string,
  state: string,
}

export interface Category {
  id: number,
  name: string,
}

export interface ISearchResult {
  currentPage: number,
  hasNextPage: boolean,
  hasPreviousPage: boolean,
  pageSize: number,
  totalCount: number,
  totalPages: number,
  items: IBusinessOrService[]
}

export interface IBusinessOrService {
  address: BusinessAddress,
  avatarPath: string,
  businessName: string,
  category?: IServiceCategory,
  coverImage: string,
  currency?: string,
  description?: string,
  about?: string,
  email: string,
  facebookUrl: string,
  googleUrl: string,
  instagramUrl: string,
  phone: string,
  galleryImages?: IGallery[],
  id: number,
  rating: number,
  reviewCount: number,
  services: IService[],
  currencyId: number,
  embedThemeSettings?: IBusinessEmbedThemeSettings | null
  bookingFormFields?: IBookingFormField[]
}

export interface IBusinessEmbedThemeSettings {
  bookButtonColor?: string | null,
  bookButtonTextColor?: string | null,
  serviceListBackgroundColor?: string | null,
  serviceNameColor?: string | null,
  serviceDescriptionColor?: string | null,
  servicePriceColor?: string | null,
  serviceDurationColor?: string | null,
  primaryColor?: string | null,
  primaryTextColor?: string | null,
  surfaceColor?: string | null,
  surfaceMutedColor?: string | null,
  textColor?: string | null,
  textMutedColor?: string | null,
  borderColor?: string | null,
  fontFamily?: string | null,
  radiusMd?: string | null,
  radiusPill?: string | null,
}



export enum AccountLicense {
  Trial,
  Individual,
  Business,
  Expired,
  Suspended,
  Canceled
}
